/**
 * Hero rotativo YASY.
 *
 * Os slides ficam sobrepostos e alternam por opacidade. A transição é feita
 * pela Web Animations API pelo mesmo motivo dos drawers: é explícita e não
 * depende da cascata nem de reflow.
 *
 * Só o vídeo do slide visível fica tocando — os outros são pausados.
 */
(function () {
  var DURACAO = 600;

  function ligar(hero) {
    if (!hero || hero.dataset.yasyLigado) return;
    hero.dataset.yasyLigado = '1';

    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-yasy-hero-slide]'));
    if (slides.length === 0) return;

    var pontos = Array.prototype.slice.call(hero.querySelectorAll('[data-yasy-hero-ponto]'));

    /* O botão é a área de toque (44px); quem muda de cor é o pontinho dentro
       dele. Em marcações antigas, sem span, o próprio botão serve. */
    function pontoVisual(p) { return p.firstElementChild || p; }
    var status = hero.querySelector('[data-yasy-hero-status]');
    var intervalo = parseInt(hero.dataset.intervalo, 10) || 7000;
    var reduzir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var atual = 0;
    var timer = null;

    /* Link de slide escondido fica fora do Tab: o teclado não pode parar num
       banner que não está na tela. */
    function focavel(s, sim) {
      var link = s.querySelector('[data-yasy-hero-link]');
      if (!link) return;
      if (sim) link.removeAttribute('tabindex');
      else link.setAttribute('tabindex', '-1');
    }

    // estado inicial: só o primeiro visível
    slides.forEach(function (s, i) {
      s.style.opacity = i === 0 ? '1' : '0';
      s.style.pointerEvents = i === 0 ? '' : 'none';
      focavel(s, i === 0);
    });

    function cuidarDosVideos() {
      slides.forEach(function (s, i) {
        var video = s.querySelector('[data-yasy-hero-video]');
        if (!video) return;
        if (i === atual) {
          var p = video.play();
          // navegadores bloqueiam autoplay com som; aqui é mudo, mas a promise
          // ainda pode falhar se a aba estiver em segundo plano
          if (p && p.catch) p.catch(function () {});
        } else {
          video.pause();
        }
      });
    }

    function mostrar(indice) {
      var anterior = atual;
      atual = (indice + slides.length) % slides.length;
      if (anterior === atual) return;

      var duracao = reduzir ? 0 : DURACAO;

      slides.forEach(function (s, i) {
        var entra = i === atual;
        var de = parseFloat(s.style.opacity || '0');
        var para = entra ? 1 : 0;
        if (de === para) return;

        if (s.animate) {
          s.animate([{opacity: de}, {opacity: para}], {duration: duracao, easing: 'ease', fill: 'forwards'});
        }
        s.style.opacity = String(para);
        s.style.pointerEvents = entra ? '' : 'none';
        focavel(s, entra);
        if (entra) s.removeAttribute('aria-hidden');
        else s.setAttribute('aria-hidden', 'true');
      });

      pontos.forEach(function (p, i) {
        var ativo = i === atual;
        p.setAttribute('aria-selected', ativo ? 'true' : 'false');
        var v = pontoVisual(p);
        v.classList.toggle('w-6', ativo);
        v.classList.toggle('bg-contrast', ativo);
        v.classList.toggle('bg-contrast/50', !ativo);
      });

      if (status) status.textContent = 'Slide ' + (atual + 1) + ' de ' + slides.length;
      cuidarDosVideos();
    }

    function proximo() { mostrar(atual + 1); }
    function anterior() { mostrar(atual - 1); }
    function iniciar() { if (!reduzir && slides.length > 1 && !timer) timer = setInterval(proximo, intervalo); }
    function parar() { if (timer) { clearInterval(timer); timer = null; } }

    var btnAnterior = hero.querySelector('[data-yasy-hero-anterior]');
    var btnProximo = hero.querySelector('[data-yasy-hero-proximo]');
    if (btnAnterior) btnAnterior.addEventListener('click', function () { parar(); anterior(); iniciar(); });
    if (btnProximo) btnProximo.addEventListener('click', function () { parar(); proximo(); iniciar(); });
    pontos.forEach(function (p, i) {
      p.addEventListener('click', function () { parar(); mostrar(i); iniciar(); });
    });

    hero.addEventListener('mouseenter', parar);
    hero.addEventListener('mouseleave', iniciar);
    hero.addEventListener('focusin', parar);
    hero.addEventListener('focusout', iniciar);
    document.addEventListener('visibilitychange', function () { if (document.hidden) parar(); else iniciar(); });

    // arrastar com o dedo
    var inicioX = null;
    hero.addEventListener('touchstart', function (e) { inicioX = e.touches[0].clientX; parar(); }, {passive: true});
    hero.addEventListener('touchend', function (e) {
      if (inicioX === null) return;
      var delta = e.changedTouches[0].clientX - inicioX;
      if (Math.abs(delta) > 45) { if (delta < 0) proximo(); else anterior(); }
      inicioX = null;
      iniciar();
    }, {passive: true});

    // marca o primeiro ponto e ajusta os vídeos já na carga
    pontos.forEach(function (p, i) {
      var v0 = pontoVisual(p);
      v0.classList.toggle('w-6', i === 0);
      v0.classList.toggle('bg-contrast', i === 0);
      v0.classList.toggle('bg-contrast/50', i !== 0);
    });
    cuidarDosVideos();
    iniciar();
  }

  function iniciarTodos(raiz) {
    Array.prototype.forEach.call((raiz || document).querySelectorAll('[data-yasy-hero]'), ligar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciarTodos(); });
  else iniciarTodos();
  document.addEventListener('shopify:section:load', function (e) { iniciarTodos(e.target); });
})();
